<template>
  <div class="page">
    <div class="public-wrap">
      <h1>{{ $t('public_nav_download') }}</h1>
      <div class="dl-grid">
        <article class="dl-card ride">
          <h2><brand-product kind="ride" /></h2>
          <div class="dl-apps two">
            <div class="dl-app">
              <span class="mark" title="Rider">R<small>™</small></span>
              <b>{{ $t('rider') }}</b>
              <div class="store-stack">
                <a class="store-btn ios" href="https://apps.apple.com" target="_blank" rel="noopener">iOS</a>
                <a class="store-btn android" href="https://play.google.com/store" target="_blank" rel="noopener">Android</a>
              </div>
            </div>
            <div class="dl-app">
              <span class="mark" title="Driver">D<small>™</small></span>
              <b>{{ $t('public_cta_driver') }}</b>
              <div class="store-stack">
                <a class="store-btn ios" href="https://apps.apple.com" target="_blank" rel="noopener">iOS</a>
                <a class="store-btn android" href="https://play.google.com/store" target="_blank" rel="noopener">Android</a>
              </div>
            </div>
          </div>
        </article>

        <article class="dl-card school">
          <h2><brand-product kind="school" /></h2>
          <div class="dl-apps three">
            <div class="dl-app">
              <span class="mark" title="School">S<small>™</small></span>
              <b>{{ $t('school') }}</b>
              <div class="store-stack">
                <a class="store-btn ios" href="https://apps.apple.com" target="_blank" rel="noopener">iOS</a>
                <a class="store-btn android" href="https://play.google.com/store" target="_blank" rel="noopener">Android</a>
              </div>
            </div>
            <div class="dl-app">
              <span class="mark" title="Family">F<small>™</small></span>
              <b>{{ $t('public_cta_family') }}</b>
              <div class="store-stack">
                <a class="store-btn ios" href="https://apps.apple.com" target="_blank" rel="noopener">iOS</a>
                <a class="store-btn android" href="https://play.google.com/store" target="_blank" rel="noopener">Android</a>
              </div>
            </div>
            <div class="dl-app">
              <span class="mark" title="Driver">D<small>™</small></span>
              <b>{{ $t('public_cta_driver') }}</b>
              <div class="store-stack">
                <a class="store-btn ios" href="https://apps.apple.com" target="_blank" rel="noopener">iOS</a>
                <a class="store-btn android" href="https://play.google.com/store" target="_blank" rel="noopener">Android</a>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<script>
import BrandProduct from '@/components/BrandProduct.vue'
export default { components: { BrandProduct } }
</script>
<style scoped>
.page { padding: 48px 0 80px; }
.public-wrap { width: min(1160px, calc(100% - 36px)); margin: 0 auto; }
h1 { margin: 0 0 28px; font-size: 2.2rem; letter-spacing: -0.03em; color: #002855; }
.dl-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }
.dl-card {
  background: #fff;
  border-radius: 28px;
  padding: 28px 24px 22px;
  box-shadow: 0 22px 50px rgba(0, 40, 85, 0.12);
}
.dl-card h2 { margin: 0 0 20px; font-size: 28px; letter-spacing: -.03em; color: #002855; }
.dl-apps { display: grid; gap: 14px; }
.dl-apps.two { grid-template-columns: 1fr 1fr; }
.dl-apps.three { grid-template-columns: 1fr 1fr 1fr; }
.dl-app {
  display: flex; flex-direction: column; align-items: center;
  text-align: center; gap: 10px;
  border-radius: 20px; padding: 16px 12px 14px;
}
.ride .dl-app { background: #fff; border: 1px solid #E5E7EB; }
.school .dl-app { background: #FFF6E4; }
.mark {
  width: 58px; height: 58px; border-radius: 16px;
  display: inline-flex; align-items: center; justify-content: center;
  font-weight: 800; font-size: 26px; color: #002855;
}
.mark small { font-size: 8px; font-weight: 700; align-self: flex-start; margin-top: 8px; }
.ride .mark { background: #fff; border: 1.5px solid #E5E7EB; box-shadow: 0 8px 18px rgba(0,40,85,.08); }
.school .mark { background: #FFA800; }
.dl-app b { font-size: 14px; color: #002855; }
.store-stack { display: flex; flex-direction: column; gap: 8px; width: 100%; }
.store-btn {
  display: flex; align-items: center; justify-content: center;
  border-radius: 12px; padding: 10px 12px; text-decoration: none;
  font-weight: 700; font-size: 13px; color: #fff;
}
.store-btn.ios { background: #111827; }
.store-btn.android { background: #002855; }
@media (max-width: 900px) {
  .dl-grid, .dl-apps.two, .dl-apps.three { grid-template-columns: 1fr; }
}
</style>
